/**
 * Created by Ivan on 11.09.2026
 */

const StickersUnitHelp2 = {
    attach: function (parent, unit, options) {
        const help = new cleverapps.UI.HelpButton({
            callback: () => cleverapps.eventBus.trigger("stickers2_unit_clicked", unit)
        });
        help.setScale(options.scale);
        help.baseScale = options.scale;
        parent.addChild(help);
        help.setAlignment(options.alignment);
    }
};
